import React from 'react';

const ThankYouPage = () => {
  return (
    <div className="thank-you-container">
      <h1>Obrigado!</h1>
      <p>Seu formulário foi enviado com sucesso.</p>
    </div>
  );
};

export default ThankYouPage;
